import { render } from "./Button.vue?vue&type=template&id=fd21a2ac&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=fd21a2ac&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd21a2ac"]])

export default __exports__